// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyStats_container__3ih5V","item":"CompanyStats_item__1uq33","itemValue":"CompanyStats_itemValue__1C06O","itemTitle":"CompanyStats_itemTitle__3O99y"};